import usePrivateAxios from '@/common/api/usePrivateAxios';
import { LastReviewValidationSchema } from '@/common/schemas/lastReview.schema';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceFiscalAssessmentDocumentDisapproveProps {
  documentId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    LastReviewValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentDocumentDisapprove = ({
  documentId,
  options,
}: UseMaintenanceFiscalAssessmentDocumentDisapproveProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentDocumentDisapprove'],
    mutationFn: (form) => {
      return privateAxios.put(`/maintenance/fiscal_assessment_documents/${documentId}/review`, {
        last_review_attributes: {
          state: 'disapproved',
          description: form.description,
        },
      });
    },
    ...options
  });
}
